import { useTranslation } from 'next-i18next'
import { SyntheticEvent } from 'react'

import { convertMsToDayHourMinute } from '~/user-stats/utility/date.utils'
import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'
import { AppLanguage } from '~/types/locale'
import { MathVaultProductAPIStat } from '~/redux/apis/user-stats-api'

import TimeSpent from '../TimeSpent'
import SummaryHeader from '../SummaryHeader'

interface Props {
  showContent: boolean
  onClick: () => void
  cardData: MathVaultProductAPIStat
}

export default function MathVaultSummary({ showContent, onClick, cardData }: Props): React.ReactElement {
  const { t } = useTranslation('statistics')
  const { days, hours, minutes } = convertMsToDayHourMinute(cardData.timeSpent)

  const idString = cardData.id.split('.').slice(1)

  const productHref = `/math-vault/${idString.join('/')}/1/1`

  const onClickTitle = (evt: SyntheticEvent): void => {
    evt.stopPropagation()
    statisticsAnalytics.logProductTileClick({ title: cardData.chest })
  }

  return (
    <button className="w-full space-y-3" onClick={onClick}>
      <SummaryHeader
        cardTitle={cardData.chest}
        hrefLocale={cardData.supportsCurrentLocale ? undefined : AppLanguage.EN}
        iconAltText={t('math-vault')}
        iconSrcKey="icons/products/math-vault.png"
        onClickTitle={onClickTitle}
        productHref={productHref}
        productSubtitle={cardData.room}
        productTitle={t('math-vault')}
        showContent={showContent}
      />
      <div className="font-medium flex flex-start">
        <TimeSpent days={days} hours={hours} minutes={minutes} />
      </div>
    </button>
  )
}
